import { CommonModule } from '@angular/common'
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core'
import { AbstractControl } from '@angular/forms'
import {
  MAT_OPTION_PARENT_COMPONENT,
  MatOptgroup,
  MatOption,
  MatOptionParentComponent,
  MatPseudoCheckboxModule,
  MatPseudoCheckboxState,
  MatRippleModule,
} from '@angular/material/core'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

@Component({
  selector: 'mmx-select-all-option',
  templateUrl: './select-all-option.component.html',
  styleUrls: ['./select-all-option.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatRippleModule,
    MatPseudoCheckboxModule,
  ],
})
export class SelectAllOptionComponent
  extends MatOption
  implements OnInit, OnDestroy
{
  protected unsubscribe: Subject<any>

  get selectedItemsCount(): number {
    return this.control && Array.isArray(this.control.value)
      ? this.control.value.filter((el) => el != null).length
      : 0
  }

  get selectedAll(): boolean {
    return this.selectedItemsCount === this.values.length
  }

  get selectedPartially(): boolean {
    const selectedItemsCount = this.selectedItemsCount

    return selectedItemsCount > 0 && selectedItemsCount < this.values.length
  }

  get checkboxState(): MatPseudoCheckboxState {
    let state: MatPseudoCheckboxState = 'unchecked'

    if (this.selectedAll) {
      state = 'checked'
    } else if (this.selectedPartially) {
      state = 'indeterminate'
    }

    return state
  }

  @Input() control: AbstractControl
  @Input() title = 'Select All'
  @Input() values: any[] = []

  @HostBinding('class') cssClass = 'mat-option'

  constructor(
    elementRef: ElementRef<HTMLElement>,
    changeDetectorRef: ChangeDetectorRef,
    @Optional()
    @Inject(MAT_OPTION_PARENT_COMPONENT)
    parent: MatOptionParentComponent,
    @Optional() group: MatOptgroup,
  ) {
    super(elementRef, changeDetectorRef, parent, group)
  }

  @HostListener('click') toggleSelection(): void {
    if (this.selectedAll) {
      this.deselect()
    } else {
      this.select()
    }

    this.control.setValue(this.selected ? this.values : [])
  }

  ngOnInit(): void {
    this.unsubscribe = new Subject<any>()

    this.refresh()

    this.control.valueChanges
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => {
        this.refresh()
      })
  }

  ngOnDestroy(): void {
    super.ngOnDestroy()

    this.unsubscribe.next(true)
    this.unsubscribe.complete()
  }

  refresh(): void {
    if (this.selectedItemsCount > 0) {
      this.select()
    } else {
      this.deselect()
    }
  }
}
